<ng-template #settingsTemplate>
    <app-tool-setting label="Vul in">
        <app-numbers-input
            (numberChoice)="handleNumberChoice($event)"
            (undo)="handleUndo()"
            (clear)="handleClear()"
        ></app-numbers-input>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg
        id="Laag_1"
        data-name="Laag 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 193.9 111"
    >
        <defs>
            <style>
                .sSchema-1 {
                    fill: #fff;
                }
                .sSchema-1,
                .sSchema-2,
                .sSchema-3 {
                    stroke: #0090c9;
                    stroke-width: 1.5px;
                }
                .sSchema-2 {
                    fill: #eaf4fb;
                }
                .sSchema-3,
                .sSchema-4 {
                    fill: none;
                }
                .sSchema-4 {
                    stroke: #a1a1a1;
                }
                .sSchema-5 {
                    font-size: 28px;
                    font-family: UniversLTStd, Univers LT Std;
                }
                .sSchema-6 {
                    letter-spacing: -0.06em;
                }
            </style>
        </defs>

        <line class="sSchema-3" x1="75.13" y1="57.08" x2="119.52" y2="89.86" />
        <line class="sSchema-3" x1="75.13" y1="56.76" x2="119.52" y2="23.98" />

        <g class="splt-schema-item-fields">
            <g class="field1" (click)="setActiveField(0)">
                <rect
                    class="sSchema-2"
                    x="0.75"
                    y="33.65"
                    width="73.5"
                    height="46.5"
                />
                <text
                    class="sSchema-5"
                    text-anchor="middle"
                    transform="translate(36.75 67.18)"
                >
                    {{ values[0] }}
                </text>
                @if (activeField === 0) {
                <g>
                    <line
                        class="sSchema-4"
                        x1="19"
                        y1="72.5"
                        x2="58"
                        y2="72.5"
                    />
                </g>
                }
            </g>

            <g class="field2" (click)="setActiveField(1)">
                <rect
                    class="sSchema-1"
                    x="119.65"
                    y="0.75"
                    width="73.5"
                    height="46.5"
                />
                <text
                    class="sSchema-5"
                    text-anchor="middle"
                    transform="translate(156.75 35.18)"
                >
                    {{ values[1] }}
                </text>
                @if (activeField === 1) {
                <g>
                    <line
                        class="sSchema-4"
                        x1="136.9"
                        y1="39.15"
                        x2="175.9"
                        y2="39.15"
                    />
                </g>
                }
            </g>

            <g class="field3" (click)="setActiveField(2)">
                <rect
                    class="sSchema-1"
                    x="119.65"
                    y="63.75"
                    width="73.5"
                    height="46.5"
                />
                <text
                    class="sSchema-5"
                    text-anchor="middle"
                    transform="translate(156.75 97.18)"
                >
                    {{ values[2] }}
                </text>
                @if (activeField === 2) {
                <g>
                    <line
                        class="sSchema-4"
                        x1="137"
                        y1="102.5"
                        x2="176"
                        y2="102.5"
                    />
                </g>
                }
            </g>
        </g>
    </svg>
</ng-template>
